module.exports = __webpack_public_path__ + "img/play.5c514e8f.svg";